import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { baseUrl } from "../config";
import { getAccessToken } from "./tokens";
import moment from "moment";

const api = process.env.NODE_ENV === "production" ? baseUrl : `${baseUrl}:5195`;

export const downloader =
  (app: IPublicClientApplication, acc: AccountInfo) =>
  (scope: string) =>
  async (date: Date, logger: (msg: string) => void) => {
    try {
      const token = await getAccessToken(app, acc, scope);

      if (!token) throw new Error("Download mislukt (403)");

      // toISOString formats with respect to UTC, so we need to adjust for timezone
      var tzo = date.getTimezoneOffset();
      const reqDate = new Date(date.setHours(date.getHours() + -tzo / 60));

      const response = await fetch(
        `${api}/slareport/${reqDate.toISOString()}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (!response.ok)
        throw new Error(`Download mislukt (${response.status})`);

      const filename = response.headers.get("x-filename");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename!;
      link.click();

      logger(`Rapport '${filename}' is opgeslagen in de downloads folder`);
    } catch (error: any) {
      console.error(error);
      logger(error.message);
    }
  };
